import React from 'react';

import { Text } from 'react-native';

import { DialogBodyProps } from '../types';

import { sharedStyles } from './shared.styles';

export const UnavailableRestaurantDialogBody: React.FC<Pick<
  DialogBodyProps,
  'body' | 'formatMessage'
>> = ({ body, formatMessage }) => {
  return (
    <Text style={sharedStyles.bodyText}>
      {body || formatMessage({ id: 'restaurantUnavailableErrorMessage' })}
    </Text>
  );
};
